import * as z from 'zod'
import { baseEntitySchema } from '../../core/entity.js'

/** One item on the band's Pinned shelf (GH #2822): seen by every member, changed by members who can edit the band */
export const bandPinSchema = z.object({
  entityId: z.string().min(1).describe('The pinned item'),
  pinnedBy: z.string().min(1).describe('The user id of the member who pinned it'),
  order: z.number().int().min(0).describe('Its place on the shelf, from 0'),
})
export type BandPin = z.infer<typeof bandPinSchema>

export const bandSpaceSchema = baseEntitySchema.extend({
  type: z.literal('bandspace'),
  pins: z.array(bandPinSchema).describe('The Pinned shelf on the band Home, at most 3').optional(),
  /** @todo use the aiConfigSchema for this - but it's in ai-lib and we cannot depend on it */
  aiConfig: z.record(z.string(), z.unknown()).optional(),
})

export type BandSpace = z.infer<typeof bandSpaceSchema>

export function isBandSpace(node?: unknown): node is BandSpace {
  return bandSpaceSchema.safeParse(node).success
}
